// @flow
import * as React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import Avatar from "components/Avatar"
import urls from "data/router/urls"
import { selectAppConfig } from "data/app/selectors"
import { logout } from "data/user/actions"
import { type User } from "data/user/types"
import { selectPrimary } from "data/user/helpers"
import { openModal } from "data/modals/actions"
import Login from "modals/Login"
import LogoLink from "components/LogoLink"
import { SidebarWrap, LogoWrap, Link } from "./styled"

const Sidebar = ({ appConfig, isOpen, close, user, login, logout }) => (
  <SidebarWrap isOpen={isOpen}>
    <LogoWrap>
      <LogoLink type="default" />
    </LogoWrap>
    {user ? (
      <React.Fragment>
        <Avatar big profile={selectPrimary(user)} />
        {appConfig && appConfig.enableBasket &&
          <Link to={urls.shoppingBasket} onClick={close}>Shopping Cart</Link>
        }
        <Link to={urls.reservations} onClick={close}>My Reservations</Link>
        <Link to={urls.account.index} onClick={close}>Account</Link>
        <Link onClick={logout}>Logout</Link>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Link exact to={urls.home} onClick={close}>
          Home
        </Link>
        <Link primary onClick={login}>
          Log in
        </Link>
      </React.Fragment>
    )}
  </SidebarWrap>
)

type Outter = {|
  isOpen: boolean,
  close: Function,
  user?: User,
|}

const mapStateToProps = state => ({
  appConfig: selectAppConfig(state),
})

const enhancer: HOC<*, Outter> = compose(
  withConnect(mapStateToProps, { openModal, logout }),
  withHandlers({
    login: props => () => props.openModal(Login, {}),
  }),
)

export default enhancer(Sidebar)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/Hamburger/Sidebar/index.js